@if (error) {
  <span [title]="error">—</span>
} @else if (display == 'date') {
  <app-date [value]="lastMod | async" empty="—" />
} @else if (display == 'numberOfFiles') {
  {{fileNo | async }}
}
